import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class RdSalesAdjPercentageEditService {

  constructor(private http: HttpClient) { }

  checkLockStatus(
    baseUrl: string,
    lockParams: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build URL for lock status check
    const url = `${baseUrl}/loadJsonObject`;
    
    // Build parameters with fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.merge({}, lockParams, params);
    
    // Convert to URL encoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  savePercentage(
    baseUrl: string,
    clobSettingsObj: any,
    clobDataDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build URL for save operation
    const url = `${baseUrl}/saveJsonObject?action_code=gtfg5p`;
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Merge with the first data object
    if (clobDataDetails && clobDataDetails.length > 0) {
      params = _.merge({}, clobDataDetails[0], params);
    }
    
    // Essential parameters with fallbacks
    params.clob_data = JSON.stringify(clobDataDetails);
    params.clob_settings = JSON.stringify(clobSettingsObj);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    
    // Add process name
    params.process_name = "RD_SALES_ADJ_PERCENTAGE_EDIT_SAVE";
    
    console.log("savePercentage EDIT params:", params);
    
    // Convert to URL encoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
